/**
 * DocumentTypeDialog · constantes partagées — extraites au cours de
 * l'iter208bis (2026-02-28) pour permettre le split du fichier principal
 * (>3000 lignes) en plusieurs modules sans dupliquer les magic values.
 */

export const REQUIRED_FIELD_TYPES = [
  { v: "text",        l: "📝 Texte" },
  // Spec iter149 (Feb 2026) — Texte à mémoire : même stockage qu'un
  // champ « text » mais à la saisie, on propose les valeurs déjà
  // utilisées pour ce champ sur ce type de document (autocomplete).
  { v: "text_memory", l: "🔖 Texte (mémoire)" },
  { v: "number",      l: "🔢 Nombre" },
  { v: "date",        l: "📅 Date" },
  { v: "money",       l: "💰 Montant (DA)" },
  { v: "dropdown",    l: "📋 Liste déroulante" },
  { v: "checkbox",    l: "☑️ Case à cocher" },
  { v: "file",        l: "📄 Fichier" },
];

export const DOC_FIELD_TYPES = REQUIRED_FIELD_TYPES;

// Valeur sentinelle utilisée par le sélecteur d'ancre de deadline pour
// signifier « depuis la création du document » (par opposition à une
// étape précédente identifiée par son id).
export const CREATION_ANCHOR = "__creation__";

// Durée en ms de l'animation « Nouvelle » pour une étape ou un champ
// fraîchement ajouté(e).
export const FRESH_MS = 5000;
